import { render, staticRenderFns } from "./EmailAttachments.vue?vue&type=template&id=cda3106c&"
import script from "./EmailAttachments.vue?vue&type=script&lang=js&"
export * from "./EmailAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports